export default __webpack_public_path__ + "static/media/NAZCA-café.99be32bc.png";